<span [class.alert]="isOverThreshold" [class.ok]="!isOverThreshold">
  {{ elapsedTime }} ({{interval}} {{"MINUTES" | translate}})
</span>
